import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/apiConfig';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, Box, TextField, Grid
} from '@mui/material';

const DocumentManagement = () => {
  const [documents, setDocuments] = useState([]);
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState({ from: '', to: '' });
  const [amountRange, setAmountRange] = useState({ min: '', max: '' });

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const res = await axios.get(getApiUrl('/api/documents'));
        setDocuments(res.data);
        setFilteredDocs(res.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchDocuments();
  }, []);

  useEffect(() => {
    const filtered = documents.filter(doc => {
      const nameMatch = doc.belegname.toLowerCase().includes(searchTerm.toLowerCase());
      const dateValid = (!dateRange.from || doc.belegdatum >= dateRange.from) &&
                        (!dateRange.to || doc.belegdatum <= dateRange.to);
      const amountValid = (!amountRange.min || parseFloat(doc.belegbetrag) >= parseFloat(amountRange.min)) &&
                          (!amountRange.max || parseFloat(doc.belegbetrag) <= parseFloat(amountRange.max));
      return nameMatch && dateValid && amountValid;
    });

    setFilteredDocs(filtered);
  }, [searchTerm, dateRange, amountRange, documents]);

  return (
    <Box width="100%" my={4}>
      <Typography variant="h6" gutterBottom>
        Hier werden alle Belege abgelegt: Kassenbons + Rechnungen.
      </Typography>

      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField fullWidth label="Suche nach Name" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <TextField fullWidth label="Datum von" type="date" InputLabelProps={{ shrink: true }} value={dateRange.from} onChange={e => setDateRange(prev => ({ ...prev, from: e.target.value }))} />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <TextField fullWidth label="Datum bis" type="date" InputLabelProps={{ shrink: true }} value={dateRange.to} onChange={e => setDateRange(prev => ({ ...prev, to: e.target.value }))} />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <TextField fullWidth label="Betrag min" type="number" value={amountRange.min} onChange={e => setAmountRange(prev => ({ ...prev, min: e.target.value }))} />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <TextField fullWidth label="Betrag max" type="number" value={amountRange.max} onChange={e => setAmountRange(prev => ({ ...prev, max: e.target.value }))} />
        </Grid>
      </Grid>

      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table size="small" sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Dokumentenname</TableCell>
              <TableCell>Speicherort</TableCell>
              <TableCell>Belegdatum</TableCell>
              <TableCell>Belegbetrag</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredDocs.map((document) => (
              <TableRow key={document.belegid}>
                <TableCell>{document.belegid}</TableCell>
                <TableCell>{document.belegname}</TableCell>
                <TableCell>{document.belegpfad}</TableCell>
                <TableCell>{document.belegdatum}</TableCell>
                <TableCell>{document.belegbetrag}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default DocumentManagement;
